import {shuffle as lodashShuffle} from "lodash"

export function shuffle(param) {
  if (Array.isArray(param)) {
    return lodashShuffle(param)
  }

  return param
}
